// extracted by mini-css-extract-plugin
module.exports = {"goodsCard":"goodscard--goods-card--32va8","goodsCard__image":"goodscard--goods-card__image--baszd","goodsCard__body":"goodscard--goods-card__body--1fH4M"};